<!--
 * @Author: 范向玲
 * @Date: 2022-10-08 16:58:00
 * @LastEditors: chenmengnan chenmengnan@piesat.cn
 * @LastEditTime: 2024-12-23 16:18:28
 * @Description:
 * @FilePath: \web\src\components\DataManagement\component\search.vue
-->
<template>
  <div class="search">
    <slot name="select"></slot>
    <!-- S 矿种选择 -->
    <div class="search-item mineral">
      <section class="mineral-type-cascader" @click="openMineral">
        {{ getPrimary }}
        <CaretDownOutlined />
      </section>

      <MineralTypeVue ref="mineralTypeVue" :visible="mineralVisible" :list="minerals" @close="openMineral"
        @submit="mineralSubmit" style="top: 0.48rem" />
    </div>
    <!-- E 矿种选择 -->

    <!-- S 矿权选择 -->
    <div class="search-item">
      <a-select class="project-rate" placeholder="矿权" v-model:value="requestParams.claimType"
        :getPopupContainer="(triggerNode) => triggerNode.parentNode">
        <a-select-option v-for="item in claimTypes" :key="item.type">
          {{ item.name }}
        </a-select-option>
        <template #suffixIcon>
          <CaretDownOutlined />
        </template>
      </a-select>
    </div>
    <!-- E 矿权选择 -->

    <!-- S 输入搜索 -->
    <div class="search-item">
      <a-input-search placeholder="请输入搜索内容" @search="submitSearch(2)" style="width: 2rem"
        v-model:value="requestParams.searchContent" />
    </div>
    <!-- E 输入搜索 -->

    <!-- S 区域选择 -->
    <div class="search-item">
      <a-select class="region-select" placeholder="区域" v-model:value="requestParams.globalRegion"
        :getPopupContainer="(triggerNode) => triggerNode.parentNode">
        <a-select-option v-for="item in regions" :key="item.type" @click="handlerClick(item.id)">
          {{ item.countryName }}
        </a-select-option>
        <template #suffixIcon>
          <CaretDownOutlined />
        </template>
      </a-select>
    </div>
    <!-- E 区域选择 -->

    <!-- S 国家选择 -->
    <div class="search-item">
      <a-select class="country-select" placeholder="国家" v-model:value="requestParams.countryName"
        :getPopupContainer="(triggerNode) => triggerNode.parentNode">
        <a-select-option v-for="item in countrys" :key="item.type">
          {{ item.countryName }}
        </a-select-option>
        <template #suffixIcon>
          <CaretDownOutlined />
        </template>
      </a-select>
    </div>
    <!-- E 国家选择 -->

    <!-- S 项目来源 -->
    <div class="search-item">
      <a-select class="project-source" placeholder="项目来源" v-model:value="requestParams.infoSource"
        :getPopupContainer="(triggerNode) => triggerNode.parentNode">
        <a-select-option v-for="item in projectSource" :key="item.type">
          {{ item.name }}
        </a-select-option>
        <template #suffixIcon>
          <CaretDownOutlined />
        </template>
      </a-select>
    </div>
    <!-- E 项目来源 -->

    <!-- S 项目级别 -->
    <div class="search-item">
      <a-select class="project-rate" placeholder="项目级别" v-model:value="requestParams.propertyLevel"
        :getPopupContainer="(triggerNode) => triggerNode.parentNode">
        <a-select-option v-for="item in rateSource" :key="item.value">
          {{ item.name }}
        </a-select-option>
        <template #suffixIcon>
          <CaretDownOutlined />
        </template>
      </a-select>
    </div>
    <!-- E 项目级别 -->

    <!-- S 中资占比 -->
    <div class="search-item zb">
      <section class="label">中资占比</section>
      <a-select class="project-rate" placeholder="" v-model:value="pctRangeLevel" @change="changePctRangeLevel">
        <a-select-option v-for="item in pctRange" :key="item.value">
          {{ item.name }}
        </a-select-option>
        <template #suffixIcon>
          <CaretDownOutlined />
        </template>
      </a-select>
    </div>
    <div class="search-item zbfw">
      <a-input-number v-model:value="requestParams.pctRange[0]" style="width: .80rem; text-align: center" placeholder=""
        min="0" :max="requestParams.pctRange[1]" />
      ~
      <a-input-number v-model:value="requestParams.pctRange[1]"
        style="width: .80rem; text-align: center; border-left: 0" placeholder="" :min="requestParams.pctRange[0]"
        max="100" />
    </div>
    <!-- E 中资占比 -->

    <slot name="btns">
      <div class="btn-wrapper">
        <div class="reset-btn btn-item search-item" @click="resetSearch">重置</div>
        <div class="search-btn btn-item" @click="submitSearch(1)">查询</div>
      </div>
    </slot>
  </div>
</template>

<script setup>
import { CaretDownOutlined, } from '@ant-design/icons-vue';
import { computed, onMounted, toRefs, ref, defineProps, defineEmits, onBeforeMount, watch, } from 'vue';
import { GET_COUNTRYS, GET_REGIONS, } from '@/store/modules/actions/projectLibrary';
import { useStore, } from 'vuex';
import MineralTypeVue from '@/components/ProjectLibrary/main/orenodeSearch/keySearch/mineralType.vue';
const props = defineProps({
  storeModule: {
    type: String,
    default: 'dataManagement',
  },
});

/**
 * 中资占比
 */
const pctRangeLevel = ref();

const emit = defineEmits(['submit',]);

const { storeModule, } = toRefs(props);

const { state, dispatch: storeDispatch, commit: storeCommit, } = useStore();
// state
const dataManagementState = computed(() => state[storeModule.value]);
const { regions, countrys, requestParams, } = toRefs(dataManagementState.value);

const generalState = computed(() => state.general);
const { minerals, claimTypes, projectSource, rateSource, pctRange, } = toRefs(generalState.value);

// action
// 重写dispatch
const dispatch = (space, methods, params) => storeDispatch(`${space || storeModule.value}/${methods}`, params);
// 重写commit
const commit = (space, methods, params) => storeCommit(`${space || storeModule.value}/${methods}`, params);

// ref
const mineralVisible = ref(false);
const mineralTypeVue = ref(null);
/**
 * 修改中资占比
 */
const changePctRangeLevel = (e) => {
  switch (e) {
    case '0':
      requestParams.value.pctRange = [0, 100,];
      break;
    case '1':
      requestParams.value.pctRange = [0, 25,];
      break;
    case '2':
      requestParams.value.pctRange = [25, 50,];
      break;
    case '3':
      requestParams.value.pctRange = [50, 75,];
      break;
    case '4':
      requestParams.value.pctRange = [75, 100,];
      break;
    default:
      requestParams.value.pctRange = [0, 100,];
      break;
  }
};

const handlerClick = (id) => {
  dispatch(null, GET_COUNTRYS, { id, });
  requestParams.value.countryName = null;
};

onBeforeMount(() => {
  dispatch(null, GET_REGIONS);
});

// computed
const getPrimary = computed(() => {
  if (!requestParams.value.primaryCommodity) {
    return '矿种';
  } else if (requestParams.value.primaryCommodity.split(',').length > 1) {
    return '多选';
  }
  return requestParams.value.primaryCommodity;
});

/**
 * @description 打开矿种选择
 */
const openMineral = () => {
  mineralVisible.value = !mineralVisible.value;
};

/**
 * @description 确认矿种选择
 */
const mineralSubmit = (value) => {
  commit(null, 'setRequestParams', { primaryCommodity: value, });
  openMineral();
};

/**
 * @description 查询
 */
const submitSearch = (searchType) => {
  requestParams.value.page = 1;
  requestParams.value.searchType = searchType;
  emit('submit');
};

/**
 * @description 重置
 */
const resetSearch = () => {
  mineralTypeVue.value.reset();
  commit(null, 'clear');
  submitSearch(1);
};

watch(requestParams, (val1) => {
  console.log('requestParams', val1);
});
watch(dataManagementState, (val1) => {
  if (val1.regions[1] && val1.regions[1].type !== '全部境外') {
    val1.regions.splice(1, 0, { id: '202,203,204,205,206,207', countryName: '全部境外', englishName: 'all Abroad', type: '全部境外', });
  }
}, {
  deep: true,
  immediate: true,
});

</script>

<style lang="scss">
.search {
  display: flex;
  // height: 0.51rem;
  // padding: 0.13rem 0.1rem;

  /** 下拉框 */
  .ant-select {
    width: 100%;
    height: 100%;

    .ant-select-selector {
      height: 100%;
    }

    .ant-select-arrow {
      color: #fff;
    }

    .ant-select-selection-item {
      line-height: .34rem;
    }

    // 背景
    &:not(.ant-select-customize-input) .ant-select-selector {
      background-color: rgba(91, 76, 39, 0.4);
      border: none;
      color: #fff;
    }

    /* 描述 */
    .ant-select-selection-placeholder {
      line-height: .34rem;
      color: #fff;
    }
  }

  /* 输入框 */
  .ant-input-search {
    width: 100% !important;
    height: 100%;
    border: transparent;
    background-color: rgba(91, 76, 39, 0.4);

    &.ant-input-affix-wrapper-foused {
      border: none;
    }

    .ant-input {
      color: white;
      background-color: transparent;
      font-size: 0.14rem;
      font-family: Microsoft YaHei;
    }

    .ant-input-suffix {
      width: 0.12rem;
      height: 0.12rem;
      margin-top: .02rem;

      .ant-input-search-icon {
        width: 100%;
        height: 100%;
        color: white;
      }
    }
  }

  .btn-wrapper {
    height: 0.32rem;
    line-height: 0.32rem;
    margin-left: 0.2rem;
    color: #ffffff;
    display: flex;
    padding: 0;

    .btn-item {
      width: 0.9rem;
      text-align: center;
      cursor: pointer;

      &:active {
        opacity: 0.8;
      }
    }

    .reset-btn {
      // background-color: #535962;
      background-image: url(~@/static/images/dataManagement/reset_btn.png);
      background-size: 100% 100%;
    }

    .search-btn {
      // background-color: #efb227;
      background-image: url(~@/static/images/dataManagement/submit_btn.png);
      background-size: 100% 100%;
    }
  }

  .search-item {
    width: 1.2rem;
    height: 0.34rem;
    margin-right: 0.05rem;

    /* 矿种单独处理 */
    &.mineral {
      position: relative;
      line-height: 0.34rem;
      background-color: rgba(91, 76, 39, 0.4);
      color: #fff;
      padding-left: .1rem;
      cursor: pointer;
    }

    &.zb {
      position: relative;
      // width: 2rem;

      .label {
        position: absolute;
        width: 100%;
        height: 0.32rem;

        color: #fff;
        text-align: center;
        line-height: 0.32rem;
        font-size: 0.14rem;
        z-index: 10;

        cursor: pointer;
        pointer-events: none;
      }

      .ant-select-selector {
        text-align: center;
        border: none;
        // background-color: transparent;

        .ant-select-selection-search {
          left: 0;
        }

        .ant-select-selection-item {
          display: none;
          flex: none;
          width: 85%;
          text-align: center;
          padding-right: 0;
          color: white;
          font-size: 0.16rem;
        }

        .ant-select-selection-placeholder {
          display: flex;
          align-items: center;
          justify-content: center;
          padding-right: 0;
          color: white;
          font-size: 0.16rem;
        }
      }
    }

    &.zbfw {
      width: 2rem;
      color: #fff;

      .ant-input-number {
        width: 100%;
        height: 100%;
        border: none;
        padding-left: 0.2rem;
        background-color: rgba(91, 76, 39, 0.4);
        color: white;

        &.ant-input-affix-wrapper-foused {
          border: none;
        }

        .ant-input-number-handler-wrap {
          display: none;
        }

        .ant-input {
          color: white;
          background-color: transparent;
          font-size: 0.14rem;
          font-family: Microsoft YaHei;
        }

        .ant-input-suffix {
          width: 0.12rem;
          height: 0.12rem;

          .ant-input-search-icon {
            width: 100%;
            height: 100%;
            color: white;
          }
        }
      }
    }
  }
}
</style>
